import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFrown, faMegaphone } from '@fortawesome/pro-solid-svg-icons';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BusinessAreaEnum } from 'app/core/enums/generated/BusinessAreaEnum';
import { PermissionRole } from 'app/core/enums/generated/PermissionRole';
import { SecurityService } from 'app/core/security/security.service';
import { SystemMessage } from 'app/core/system-message/system-message-service';
import { NotificationService } from 'app/notification.service';
import { FormElementsModule } from 'app/shared/form-elements/form-elements.module';

@Component({
    selector: 'pcg-ci-complaints',
    templateUrl: './ci-complaints.component.html',
    styleUrls: ['./ci-complaints.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FontAwesomeModule
        , FormElementsModule
        , NgbTooltipModule
    ],
})
export class CiComplaintsComponent implements OnInit {
    private sec = inject(SecurityService);
    httpClient = inject(HttpClient);
    router = inject(Router);
    toastr = inject(NotificationService);

    faMegaphone = faMegaphone;
    faFrown = faFrown;  
    isUser = signal<boolean>(false);

    ngOnInit() {
        this.sec.user$.subscribe((user) => {
            this.setIsUser();
        });

        this.setIsUser();
    }

    setIsUser = () =>
        this.isUser.set(this.sec.hasModuleAccess([BusinessAreaEnum.CI], [PermissionRole.User, PermissionRole.UserAdmin], false));

    raiseComplaint() {
        this.httpClient.get('api/HelpDesk/HelpDeskTicket/CreateTicket').subscribe((msg: SystemMessage) => {
            if (msg.isSuccessful) {
                this.router.navigateByUrl(`/support/tickets/edit/${msg.value}?request=ciRepackComplaint`);
            } else {
                this.toastr.showError(msg.message);
            }
        });
    }
}
